"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUrlWithFilters = exports.getWeekDay = exports.normalizeFetchedSuggestions = exports.normalizeSuggestionSelection = exports.normalizeSavedSearches = exports.combineSearches = exports.highlightText = exports.encodeAndStringify = void 0;
var constants_1 = require("./constants");
function removeNonUTF8(str) {
    return str.replace(/[^\x00-\x7F]/g, '');
}
function encodeAndStringify(input) {
    return btoa(removeNonUTF8(JSON.stringify(input)));
}
exports.encodeAndStringify = encodeAndStringify;
/**
  ----------------- highlightText function output example -----------------------

  Original Keyword = "Honda Civic Coup w Honda/Sensing"

  User Input = "Hon"
  Return highlightedText = "<span class="search-result-bold-phrase">Hon</span>da Civic Coup w <span class="search-result-bold-phrase">Hon</span>da/Sensing"

  User Input = ""
  Return keyword = "Honda Civic Coup Honda/Sensing"
*/
function highlightText(keyword, searchString) {
    if (!searchString)
        return keyword;
    var startTag = '<span class="font-bold">';
    var endTag = '</span>';
    var re = new RegExp(searchString, 'gi');
    return keyword.replace(re, startTag + '$&' + endTag);
}
exports.highlightText = highlightText;
function combineSearches(_a) {
    var recentSearches = _a.recentSearches, savedSearches = _a.savedSearches;
    var savedSearchesLength = savedSearches.length < 3 ? savedSearches.length : 3;
    var recentSearchesLength = recentSearches.length < 5 ? recentSearches.length : 5;
    return __spreadArray(__spreadArray([], savedSearches.slice(0, Math.max(0, 8 - recentSearchesLength)), true), recentSearches.slice(0, Math.max(0, 8 - savedSearchesLength)), true);
}
exports.combineSearches = combineSearches;
function normalizeSavedSearches(_a) {
    var data = _a.data, _b = _a.inputValue, inputValue = _b === void 0 ? '' : _b;
    if (!data)
        return [];
    return data.map(function (savedSearch) {
        var name = savedSearch.name, url = savedSearch.url;
        return {
            searchType: constants_1.SearchType.SavedSearch,
            text: name,
            highlightedText: highlightText(name, inputValue),
            searchHash: url,
            href: "/cars/filters?cvnaid=".concat(url)
        };
    });
}
exports.normalizeSavedSearches = normalizeSavedSearches;
var normalizeSuggestionSelection = function (suggestion) {
    var searchHash = 'filters' in suggestion
        ? encodeAndStringify({
            filters: suggestion.filters
        })
        : suggestion.searchHash;
    return {
        buildKey: 'buildKey' in suggestion ? suggestion.buildKey : null,
        highlightedText: suggestion.highlightedText,
        href: 'href' in suggestion
            ? suggestion.href
            : "/cars/filters?cvnaid=".concat(searchHash),
        searchHash: searchHash,
        searchType: suggestion.searchType,
        text: suggestion.text
    };
};
exports.normalizeSuggestionSelection = normalizeSuggestionSelection;
function normalizeFetchedSuggestions(_a) {
    var data = _a.data, _b = _a.inputValue, inputValue = _b === void 0 ? '' : _b, _c = _a.searchType, searchType = _c === void 0 ? constants_1.SearchType.TextSearch : _c;
    if (!data)
        return [];
    return data.map(function (_a, index) {
        var text = _a.text, rest = __rest(_a, ["text"]);
        return (__assign(__assign({}, rest), { searchType: searchType, suggestionIndex: index, text: text, highlightedText: highlightText(text, inputValue) }));
    });
}
exports.normalizeFetchedSuggestions = normalizeFetchedSuggestions;
function getWeekDay(daysToSkip) {
    if (daysToSkip === void 0) { daysToSkip = 0; }
    var weekDays = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    var day = new Date();
    day.setDate(day.getDate() + daysToSkip);
    return weekDays[day.getDay()];
}
exports.getWeekDay = getWeekDay;
function generateUrlWithFilters(filters) {
    return filters
        ? "/cars/filters?cvnaid=".concat(encodeAndStringify(filters))
        : '/cars';
}
exports.generateUrlWithFilters = generateUrlWithFilters;
//# sourceMappingURL=utils.js.map